import React from 'react'

import './ErrorPages.css';


export const page404 = ({ ...props }) => (
    <div className="container-errorpage">
        <img className="image-errorpage" src="/assets/images/erro-404.svg" alt="" />
        <div>
            <h1>Lamentamos, mas não tem nada aqui.</h1>
            <br />
            Verifique se o endereço está correto ou volte à home para fazer uma pesquisa.
            <br /><br />
            É muito perigoso viajar por aí sem um <strong>Seguro</strong>. <br />
        </div>
        <div>
            <a href="/" className="btn-voltar">
                <img src="/assets/images/arrow-left.svg" alt="" />
                &nbsp;Voltar ao início
            </a>
        </div>
        <p>
            <strong>Precisa de ajuda?</strong> <br /><br />
            <span>Em caso de dúvidas entre em contato com o nosso atendimento.</span>
        </p>
        <p className="phones">
            4003-8442
            <br />
            (31) 3972-7083 - WhatsApp
        </p>
    </div>
)

export const page500 = ({ ...props }) => (
    <div className="container-errorpage">
        <img className="image-errorpage" src="/assets/images/erro-processar-compra.svg" alt="" />
        <div>
            <h1>Lamentamos! Algo saiu errado. </h1>
            <br />
            Nosso servidor enfrentou algum problema mas já estamos trabalhando para corrigir a situação.
            <br />
            Por favor, volte ao início e tente novamente em um minuto.
            <br />
        </div>
        <div>
            <a href="/" className="btn-voltar"><img src="/assets/images/arrow-left.svg" alt="" />
                &nbsp;Voltar
            </a>
        </div>
        <p>
            <strong>Precisa de ajuda?</strong> <br /><br />
            <span>Em caso de dúvidas entre em contato com o nosso atendimento.</span>
        </p>
        <p className="phones">
            4003-8442
            <br />
            (31) 3972-7083 - WhatsApp
        </p>
    </div>
)



// WEBPACK FOOTER //
// ./src/views/error_pages/ErrorPages.jsx